import { render, staticRenderFns } from "./CreateModelCompose.vue?vue&type=template&id=1a317682&scoped=true&"
import script from "./CreateModelCompose.vue?vue&type=script&lang=js&"
export * from "./CreateModelCompose.vue?vue&type=script&lang=js&"
import style0 from "./CreateModelCompose.vue?vue&type=style&index=0&id=1a317682&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a317682",
  null
  
)

export default component.exports